<template>
  <div class="comment-item">
    <div class="left">
      <img :src="comment[0].user && comment[0].user.avatar" @error="imgOnError" alt="">
    </div>
    <div class="right">
      <div class="inner-section-1">
        <div class="name-box">
          <div class="line-1">
            <p class="name">{{comment[0].user && comment[0].user.username}}</p>
            <div class="static-color-name-tags">
              <p class="author" v-if="comment[0].is_link_owner">作者</p>
              <div :class="`level static-color-hb-lv-${comment[0].user.level_info.level}`" v-if="comment[0].user.level_info">
                <p>Lv.{{comment[0].user && comment[0].user.level_info && comment[0].user.level_info.level}}</p>
              </div>
            </div>
          </div>
          <div class="line-2">
            <span class="static-color-hot-tag" v-if="comment[0].is_top"></span>
            <p class="text-info">{{comment[0].create_at | handleTime}}{{comment[0].ip_location ? '·' + comment[0].ip_location : ''}}</p>
          </div>
        </div>
        <div class="thumb-box">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="like" @click="likeThisComment()">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.98821 4.75055C8.93937 5.21947 8.88591 5.73274 8.60523 6.25219C8.42376 6.58803 7.93673 7.00035 7.43751 7.38241V16.5628C8.00273 16.823 8.67035 17 9.625 17H14.875C15.3125 17 15.7557 16.7165 15.9598 16.274L16.0452 16.0889C16.2107 15.7299 16.3279 15.3505 16.3934 14.9607L16.5595 13.9737C16.5746 13.8841 16.5993 13.7963 16.6334 13.712L16.9454 12.9113C17.1089 12.4916 17.197 12.0464 17.2056 11.5961L17.2203 10.8234C17.2203 10.7277 17.2313 10.6324 17.253 10.5392C17.3011 10.3324 17.3599 10.12 17.4294 9.90199C17.6439 9.22865 17.357 8.49719 16.7417 8.14886L16.3046 7.90141C15.8581 7.64863 15.3571 7.50721 14.8442 7.48915L11.8125 7.38241C12.4507 2.95685 10.4674 2.80086 9.88154 3.09107C9.12185 3.46738 9.06002 4.06101 8.98821 4.75055ZM3.9375 7.375C3.69588 7.375 3.5 7.57088 3.5 7.8125V16.4956C3.5 16.7618 3.73581 16.9663 3.99937 16.9287L6.5625 16.5625V7.375H3.9375Z" 
            :fill="comment[0].islike ? '#006EF4' :'#C8CDD2'"/>
          </svg>
          <p class="like-number">{{comment[0].up}}</p>
        </div>
      </div>
      <p class="inner-section-2" v-html="handleComments(comment[0].text)" v-if="emoji"></p>
      <div class="inner-section-3" v-if="comment[0].has_imgs == 1">
        <img :src="img.url" class="comment-img" v-for="img in comment[0].imgs" :key="img">
      </div>
      <div class="inner-section-4" v-if="comment.length > 1">
        <div class="sub-comment-item" v-for="item, _index in (comment.length > 2 ? comment[0].show ? 2 : (comment.length - 1) : (comment.length - 1) )" :key="_index">
          <span class="sub-user">{{comment[_index + 1] && comment[_index + 1].user.username}}<span class="author-tag" v-if="comment[_index + 1] && comment[_index + 1].is_link_owner == 1">作者</span></span>
          <span class="middle-text">回复 {{comment[_index + 1] && comment[_index + 1].replyuser.username}}：</span>
          <span class="content" v-html="handleComments(comment[_index + 1].text)" v-if="emoji"></span>
          <span class="send-time">{{comment[_index + 1].create_at | handleTime}}{{comment[_index + 1].ip_location ? '·' + comment[0].ip_location : ''}}</span>
        </div>
      </div>
      <div class="show-more" v-if="comment.length > 3 && comment[0].show" @click="showMoreComments(index)">
        <OutOpen :protocol="heybox_protocol" :page-identifier="'bbs/link'"  v-deeplink></OutOpen>
        全部<span>{{comment.length - 1}}</span>条回复
        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4 10V3L8 6.5L4 10Z" fill="#8C9196"/>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
import {formDate, executeProtocolOutApp} from '_lib/utils'
import { LINK_PROTOCOL } from '../assets/js/global'
import OutOpen from '_com/OutOpen'
import Emoji from '_lib/emoji'

export default {
  components: {
    OutOpen
  },
  props: {
    comment: {
      type: Array,
      default: () => []
    },
    linkInfo: {
      type: Object,
      default: () => ({}),
    },
    isConcept: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      emoji: new Emoji(),
      heybox_protocol: LINK_PROTOCOL
    }
  },
  methods: {
    // 点赞评论
    likeThisComment (index) {
      return
      if (this.comment[0].unlike) {
        this.unlikeThisComment()
      }
      this.comment[0].islike = !this.comment[0].islike
    },

    // 不喜欢评论
    unlikeThisComment (index) {
      return
      if (this.comment[0].islike) {
        this.likeThisComment()
      }
      this.comment[0].unlike = !this.comment[0].unlike
    },

    // 展示更多评论
    showMoreComments (index) {
      executeProtocolOutApp({
        "protocol_type": "openLink",
        "link": {
          "linkid": this.linkInfo.link_id,
          "link_tag": LINK_TAG,
          "use_concept_type" : this.isConcept ? 1 : 0
        }
      })
      // this.comment[0].show = !this.comment[0].show
    },
    // 图片加载失败使用默认头像
    imgOnError(e) {
      let img = e.srcElement
      img.src = 'https://cdn.max-c.com/app/heybox/icon_83.5@3x.png?imageMogr2/thumbnail/!100p/format/jpg'
      img.imgOnError = null
    },
    // 处理评论 
    handleComments (comment) {
      let svg = `<svg class="game-svg" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.16895 7.32843V6.0111H4.31537V7.32843H2.96387V8.16043H4.31537V9.47777H5.16895V8.16043H6.52046V7.32843H5.16895ZM0.0271644 12.2741L2.13138 3.99408C2.31315 3.34793 2.91568 2.89999 3.60306 2.89999H4.67581C5.15793 2.89999 5.6117 3.12207 5.89967 3.49896L6.51071 4.29865C6.6547 4.4871 6.88158 4.59814 7.12264 4.59814H8.9078C9.15258 4.59814 9.38249 4.48367 9.52597 4.29037L10.1011 3.51554C10.3881 3.12893 10.8479 2.89999 11.3374 2.89999H12.3969C13.0843 2.89999 13.6869 3.34793 13.8686 3.99408L15.9728 12.2741C16.031 12.4807 15.9948 12.7017 15.8738 12.8805L15.274 13.766C15.1328 13.9745 14.8936 14.1 14.6372 14.1H11.7982C11.4588 14.1 11.1602 13.8814 11.0655 13.5637L10.31 11.8277C10.2153 11.51 9.91669 11.2914 9.57724 11.2914H6.45435C6.11751 11.2914 5.82052 11.5067 5.72361 11.8212L4.93798 13.5703C4.84107 13.8847 4.54408 14.1 4.20724 14.1H1.36276C1.10643 14.1 0.867227 13.9745 0.726003 13.766L0.126246 12.8805C0.0051533 12.7017 -0.0309573 12.4807 0.0271644 12.2741ZM11.2602 9.47777C12.2423 9.47777 13.0385 8.70173 13.0385 7.74443C13.0385 6.78714 12.2423 6.0111 11.2602 6.0111C10.2781 6.0111 9.48189 6.78714 9.48189 7.74443C9.48189 8.70173 10.2781 9.47777 11.2602 9.47777ZM11.2602 8.75553C10.6873 8.75553 10.2228 8.30284 10.2228 7.74442C10.2228 7.186 10.6873 6.73331 11.2602 6.73331C11.8331 6.73331 12.2975 7.186 12.2975 7.74442C12.2975 8.30284 11.8331 8.75553 11.2602 8.75553Z" fill="#004B96"/>
</svg>
`
      let _comment = comment
      _comment = this.emoji.replaceEmojiByName(_comment)
      _comment = _comment.replace(/data-link-type="game"(.*?>)/gs, `$1${svg}`)
      return _comment
    }
  },
  filters: {
    // 处理时间
    handleTime (time) {
      return formDate(time, 2)
    },
  }
}
</script>
<style lang="less">
  .comment-item {
    position: relative;
    display: flex;
    align-items: flex-start;
    padding: 14px 0;
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      display: block;
      height: 1px;
      width: 100%;
      background: #F3F4F5;
      transform: scaleY(.5);
    }
    a {
      position: relative;
      display: inline-flex;
      align-items: center;
      margin-left: 24px;
      .game-svg {
        position: absolute;
        right: calc(100% + 4px);
      }
    }
    .left {
      padding: 0 10px;
      img {
        height: 34px;
        width: 34px;
        border-radius: 50%;
      }
    }
    .right {
      flex: 1;
      width: 0;
      padding-right: 10px;
      .inner-section-1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .name-box {
          .name {
            display: flex;
            align-items: center;
            font-size: 14px;
            line-height: 18px;
            font-weight: 600;
            margin-right: 3px;
            max-width: 160px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #14191e;
          }
          .static-color-name-tags {
            height: 36px;
            display: flex;
            align-items: center;
            transform: scale(.5);
            transform-origin: left;
            .author {
              height: 26px;
              padding: 0 8px;
              margin-left: 12px;
              border-radius: 2px;
              line-height: 26px;
              text-align: center;
              font-size: 16px;
              color: #FFFFFF;
              background: #14191E;
            }
            .level {
              margin-left: 12px;
              height: 40px;
              padding: 0 8px;
              border-radius: 8px;
              line-height: 40px;
              font-size: 29px;
              font-weight: 700;
              font-family: 'Helvetica';
              color: #FFFFFF;
              position: relative;
              transform: scale(0.5);
              transform-origin: left center;
              p {
                position: relative;
              }
            }
          }
          .line-1 {
            height: 18px;
            display: flex;
            align-items: center;
          }
          .line-2 {
            display: flex;
            align-items: center;
            margin-top: 3px;
            font-size: 12px;
            .static-color-hot-tag {
              position: relative;
              width: 28px;
              height: 13px;
              margin-right: 6px;
              &::after {
                content: '热评';
                position: absolute;
                left: 0;
                top: 0;
                height: 26px;
                padding: 0 8px;
                border-radius: 2px;
                line-height: 26px;
                text-align: center;
                font-size: 16px;
                color: #FFFFFF;
                white-space: nowrap;
                background: linear-gradient(45deg, rgba(255, 159, 0, 1), rgba(245, 128, 69, 1));
                transform: scale(.5);
                transform-origin: left top;
              }
            }
            .text-info {
              line-height: 15px;
              color: #8c9196;
            }
          }
        }
        .thumb-box {
          display: flex;
          align-items: center;
          .like {
            transform: translate(0, -1px);
          }
          .unlike {
            transform: translate(0, 1px);
          }
          .like-number {
            margin: 0 6px;
            font-size: 12px;
            color: #8c9196;
          }
        }
      }
      .inner-section-2 {
        margin-top: 4px;
        font-size: 15px;
        line-height: 24px;
        vertical-align: center;
        word-break: break-all;
        color: #14191E;
      }
      .inner-section-3 {
        width: 100%;
        margin-top: 6px;
        .comment-img {
          display: inline-block;
          height: 56px;
          width: 56px;
          margin-right: 4px;
          border-radius: 2px;
          object-fit: cover;
        }
      }
      .inner-section-4 {
        margin-top: 8px;
        padding: 10px;
        background: #fafbfc;
        .sub-comment-item {
          font-size: 13px;
          line-height: 19px;
          color: #14191e;
          vertical-align: baseline;
          .sub-user {
            display: inline-flex;
            align-items: center;
            height: 19px;
            white-space: nowrap;
            color: #004B96;
            .author-tag {
              padding: 0 3px;
              margin-left: 4px;
              border-radius: 2px;
              font-size: 10px;
              line-height: 12px;
              color: #FFFFFF;
              background: #14191E;
            }
          }
          .middle-text {
            display: inline-block;
            height: 19px;
            margin-left: 5px;
            white-space: nowrap;
            color: #8c9196;
          }
          .content {
            display: inline;
            text-align: left;
            word-break: break-all;
            width: 100%;
          }
          .send-time {
            font-size: 10px;
            margin-left: 2px;
            word-break: keep-all;
            white-space: nowrap;
            color: #8c9196;
          }
        }
      }
      .show-more {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 30px;
        margin-top: -4px;
        font-size: 12px;
        line-height: 17px;
        color: #8C9196;
        background: #fafbfc;
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          height: 1px;
          width: 100%;
          background: #F3F4F5;
          transform: scaleY(.5);
        }
        span {
          margin: 0 2px;
        }
        svg {
          margin-left: 2px;
        }
      }
    }
  }
</style>